<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-08-03 15:26:03
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-18 15:21:55
 * @FilePath: \partner.chaoyongtuan.com\src\views\cooperativeShop\collaborateRules\viewRules\components\ruleItem.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="ruleList_item yx-border">
		<div class="ruleList_item_title flex-row">
			<slot name="title" />
			<span v-if="showExplain" class="fz-12 yx-color-primary cursor-pointer" @click="showRuleExplainDialog">《规则说明》</span>
			<el-switch v-if="showSwitch" :value="open" @change="toggleSwitch" class="ml-24" :active-value="1" :inactive-value="0"></el-switch>
		</div>
		<div class="mt-12 mb-12" style="margin-left: 40px">
			<slot />
		</div>

		<RuleExplainDialog ref="ruleExplainDialog">
			<slot name="ruleText"></slot>
		</RuleExplainDialog>
	</div>
</template>

<script>
import RuleExplainDialog from './ruleExplainDialog';
export default {
	data() {
		return {
			open: false,
		};
	},
	props: {
		showExplain: {
			type: Boolean,
			default: true,
		},
		platformId: {
			type: [Number, String],
		},
		showSwitch: {
			type: Boolean,
			default: false,
		},
		openFlag: {
			type: [Number, String],
			default: 0,
		},
		flag: {
			type: Number,
			default: 1,
		},
		showCustomRuleDialog: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		openFlag: {
			handler: function (val) {
				this.open = val;
			},
			immediate: true,
			deep: true,
		},
	},
	components: {
		RuleExplainDialog,
	},
	methods: {
		toggleSwitch(val) {
			this.$emit('toggleSwitch', val);
		},
		showRuleExplainDialog() {
			if (this.showCustomRuleDialog) {
				this.$emit('showCustomRuleDialog', this.flag, this.platformId);
				return;
			} else {
				this.$refs.ruleExplainDialog.show(this.flag, this.platformId);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.ruleList_item {
	border-radius: 8px;
	margin-top: 16px;
	overflow: hidden;
	.ruleList_item_title {
		display: flex;
		align-items: center;
		background: #f5f8fd;
		height: 48px;
		line-height: 48px;
		padding-left: 14px;
	}
}
</style>
